import React, { Component } from "react";
import styles from "../FormSubmissionReplies/FormSubmissionReplies.module.scss";
import { Input3, Checkbox,  Button2, SearchBar, ErrorSection, ThankYouSection, BackButton } from "..";
import {
  STAGES,
  typeOptions,
  switchOptions,
} from "./constants";

import { EMAIL_REGEX, PHONE_REGEX, BEATBREAD_PRIVACY_POLICY } from "../../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import * as Yup from "yup";
import { ReactComponent as Arrows } from "../../assets/SVGs/double-chevron-right.svg";
import { HUBSPOT_API_URL, TERM_OF_USE } from "../../routes/constants";
import SingleFileUploadFiles from "../FileUpload/SingleFileUploadFiles";
import _ from "lodash";
import request from "../../utils/request";
import { toast } from "react-toastify";
import { Form, Formik } from "formik";

class DealCompForm extends Component {
  constructor() {
    super();
    this.state = {
      updatedFormData: {
        description: "",
        checked: false,
        name: "",
        email: "",
        label: "",
        phone: "",
        switch: "",
        type: "",
      },
      artistName: "",
      id: "",
      image: "",
      typeSettings: typeOptions,
      switchSettings: switchOptions,
      selectOptions: [],
      files: [],
      stage: STAGES.INITIAL,
      loader: false,
      
    };
  }

  resetState = (additionalStates = {}) => {
    this.setState({
      updatedFormData: {
        description: "",
        checked: false,
        name: "",
        email: "",
        label: "",
        phone: "",
        switch: "",
        type: "",
      },
      artistName: "",
      id: "",
      image: "",
      typeSettings: typeOptions,
      switchSettings: switchOptions,
      ...additionalStates,
    });
  };

  changeComponentErr = (alertText) => {
    return <ErrorSection onClick={this.renderInitial} subtitle={alertText}/>;
  };

  changeComponentSuc = () => {
    return <ThankYouSection subtitle="We are reviewing the information that you provided. We'll be in touch in the next few days."/>;
  };

  emailValidation = () => EMAIL_REGEX;

  handleSubmit = (values) => {
    this.setState({ loader: true });
    const a = !!(values.label || this.state.id);
    if (a === true) {
      const params = new URLSearchParams(window.location.search);
      const { files } = this.state;
      const hubspotLabel = params.get("label_id");
      const formData = new FormData();
      formData.append("type", values.type ? values.type : "None");
      formData.append("label", values.label ? values.label : "None");
      formData.append("artistName", this.state.artistName ? this.state.artistName : "None");
      formData.append("id", this.state.id ? this.state.id : "None");
      formData.append("switch", values.switch ? values.switch : "None");
        formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      formData.append("description", values.description);
      files.forEach((file) => {
        formData.append("reports", file, file.name);
      });
      formData.append("checked", values.checked);
      formData.append("label_form_source", hubspotLabel ? hubspotLabel : "beatBread");
      const data = {
        method: "POST",
        body: formData,
        headers: {
        "Access-Control-Allow-Origin": "*",
        "Accept": "application/json"
        },
      };
      const requestURL = `${HUBSPOT_API_URL}/hubspot/deal_comparison_contact/`;
      request(requestURL, data)
        .then((res) => {
          this.setState({ loader: false });
          this.setState({ stage: "success" });
        })
        .catch((err) => {
          this.setState({ loader: false });
          this.setState({ alertText: err.message });
          this.setState({ stage: "error" });
        })
        .finally(() => {
          this.resetState();
        });
    } else {
      const errorMsg = "Please input an artist or label name.";
      toast.error(errorMsg);
      this.setState({ loader: false });
    }

  };

  handleLabel = () => {
    const label = this.state.type === "Artist" ? "artist": this.state.type === "Label" ? "label" : "artist or label";
    const newLabel =  "Can this "+label+" switch distributors?"
    return newLabel;
  };

  updateArtist = (e) => {
    if (e) {
      if (e.value) {
        document.getElementsByClassName(
          "select-search__input-container"
        )[0].style.display = "none";
      }
      this.setState({ id: e.value, artistName: e.label, image: e.imageUrl });
    }
  };

  updateFileList = (file, isDelete) => {
    const { files } = this.state;
    if (isDelete) {
      _.remove(files, (f) => f.name === file.name);
    } else {
      files.push(file);
    }
    this.setState({ files });
  };

  renderSearchBar = () => (
    <SearchBar standalone onUpdateArtist={(e) => this.updateArtist(e)}/>
  );

  renderWidgetForm = () => (
    <Formik 
      initialValues={this.state.updatedFormData}
      validationSchema={this.formikValidation}
      onSubmit={this.handleSubmit}>
      {({ values }) => (  
        <Form className={styles.widgetBoxForm}>
          <div className={styles.heading}>
            <h2 className={styles.ogTitle}>
            Share a few details and we’ll be in touch.
            </h2>
          </div>
          <div className={styles.form}>
            <Input3
              input="boxes"
              title="Are you looking to compare deals for an artist or a label?"
              name="type"
              options={this.state.typeSettings}
              disabled={this.state.loader}
              full
              md
            />
            {values.type === "Artist" && (
              this.renderSearchBar()
            )}
            {values.type === "Label" && (
              <Input3
                label="Label Name"
                name="label"
                autoComplete="organization"
                placeholder="beatBread"
                disabled={this.state.loader}
              />
            )}
            <Input3
              label={this.handleLabel()}
              name="switch"
              input="radio"
              options={this.state.switchSettings}
              disabled={this.state.loader}
            />
            <Input3
              label="Contact Name"
              name="name"
              autoComplete="name"
              placeholder="John Doe"
              disabled={this.state.loader}
            />
            <Input3
              label="Email Address"
              name="email"
              type="email"
              autoComplete="email"
              placeholder="johndoe@email.com"
              disabled={this.state.loader}
            />
            <Input3
              label="Phone Number"
              name="phone"
              autoComplete="phone"
              placeholder="+1 (555) 555-5555"
              disabled={this.state.loader}
            />
            <Input3
              title="Tell us all about your offer(s)"
              placeholder="Begin Typing..."
              name="description"
              input="textarea"
              disabled={this.state.loader}
            />
            <SingleFileUploadFiles
              updateFileList={this.updateFileList}
              isUploadReports={true}
              link={true}
              linkDescription="Have a copy of your offer(s)?"
              selectOptions={this.state.selectOptions}
              totalFiles={this.state.files.length}
              loading={this.state.loader}
              {...this.props}
            />
          </div>
          <div className={styles.checkboxClass}>
            <Checkbox input="checkbox" name="checked"> 
              <div className={styles.checkLabel}>
                I agree to beatBread’s{" "}
                <a href={TERM_OF_USE} target="_blank" rel="noreferrer">
                  Terms of Service
                </a>{" "}
                and acknowledge beatBread’s{" "}
                <a href={BEATBREAD_PRIVACY_POLICY} target="_blank" rel="noreferrer">
                  Privacy Notice
                </a>
                . I consent to receive beatBread messages via SMS. Standard call,
                message, or data rates may apply.
              </div>
            </Checkbox>
          </div>
          <Button2
            full
            className={styles.submit}
            type="submit"
            disabled={this.state.loader}
          >
          {this.state.loader ? (
            <FontAwesomeIcon icon={faCircleNotch} className="spin" />
          ):(<><p>SUBMIT</p> <Arrows /></>)} 
        </Button2>
        </Form>
      )}
    </Formik>
  );

  renderInitial = () =>
    this.setState({
      stage: STAGES.INITIAL,
    });

  formikValidation = Yup.object().shape({
    type: Yup.string()
      .label("Deal Type")
      .required("Please select which deal type you are looking for."),
    label: Yup.string().label("Label Name"),
    switch: Yup.string()
      .label("Switch Distributors")
      .required("Please let us know if you are able to switch distributors."),
    name: Yup.string().label("Contact Name").required(),
    email: Yup.string()
      .label("Email")
      .required()
      .matches(EMAIL_REGEX, "Please enter valid email"),
    phone: Yup.string().label("Phone Number").required().matches(PHONE_REGEX, "Please enter a valid phone number"),
    description: Yup.string().label("Description").required("Please tell us about your offer(s)"),
    checked: Yup.bool().required().oneOf(
      [true],
      "Please agree to the Privacy Policy before proceeding."
    )
  });

  handleBackNavigation = () => {
    if (this.state.stage === STAGES.INITIAL) {
      return (<BackButton />);
    } else {
      return (<BackButton onClick={() => this.setState({stage: STAGES.INITIAL})} />);
    }
  }

  setStage = () => {
    switch (this.state.stage) {
      case STAGES.INITIAL:
        return this.renderWidgetForm();
      case STAGES.SUCCESS:
        return this.changeComponentSuc();
      case STAGES.ERROR:
        return this.changeComponentErr(this.state.alertText);
      default:
        return this.renderWidgetForm();
    }
  }

  render() {
    return (
      <div className={styles.DealCompForm}>
        {this.setStage()}
        {this.handleBackNavigation()}
      </div>  
    );
  }
}

export default DealCompForm;
